<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

            <!-- <div class="btn_menu_contextual" @click="set_modulo('busqueda')">
                Búsqueda
            </div> -->


        </div>

        <div class="contenido_">
            <Lista />
        </div>
        <!-- <Busqueda v-if="modulo == 'busqueda'" /> -->

    </div>
</template>

<script>

    import Lista from './Lista.vue'

    export default {
        name: 'Menu',
        components: {
            Lista
        },
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style></style>